// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MoreButton_wrapper__vXOVe","text":"MoreButton_text__56A34","icon":"MoreButton_icon__q0Zuh"};